import React from 'react';
import classNames from 'classnames';
import { Close, Done } from '@material-ui/icons';

import HelpButton from 'components/UI/Buttons/HelpButton/HelpButton';

import styles from './TextWidget.module.scss';

export default function TextWidget({
  children,
  classes,
  done,
  error,
  helperText,
  icons,
  model = 'primary',
  type = 'text',
  inputRef,
  ...props
}: TextWidgetType): JSX.Element {
  return (
    <div
      className={classNames(
        styles.container,
        styles[model],
        {
          [styles.done]: !!done,
          [styles.error]: !!error,
        },
        classes?.inputContainer
      )}
    >
      <input
        className={classNames(styles.input, classes?.input)}
        type={type}
        ref={inputRef}
        {...props}
      />
      <div className={classNames(styles.icons, classes?.icons)}>
        <Close className={classNames(styles.closeIcon, classes?.closeIcon)} />
        <Done className={classNames(styles.doneIcon, classes?.doneIcon)} />
        {helperText && <HelpButton classes={{ button: styles.helpButton }} />}
        {icons && icons}
      </div>
      {children}
    </div>
  );
}

export type TextWidgetType = React.InputHTMLAttributes<HTMLInputElement> &
  React.PropsWithChildren<{
    classes?: TextWidgetClassesType;
    done?: boolean;
    error?: boolean;
    helperText?: string;
    icons?: JSX.Element;
    model?: 'primary' | 'secondary';
    type?: 'text' | 'password' | 'email';
    inputRef?: React.LegacyRef<HTMLInputElement>;
  }>;

export type TextWidgetClassesType = {
  closeIcon?: string;
  doneIcon?: string;
  icons?: string;
  input?: string;
  inputContainer?: string;
};
